import { get } from 'lodash';

import tvtApi from '../services/tvt-api';

import { resetError, checkHealthStatus } from './error-actions';
import {
  getFiltersConfig,
  resetFilters,
  resetFiltersAll
} from './filters-actions';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_ERROR = 'LOGIN_ERROR';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

export const TOKEN_STORAGE_KEY = 'auth_token';
export const LOGGED_IN_STORAGE_KEY = 'logged_in';
export const USER_PROFILE_STORAGE_KEY = 'user_profile';

export const loginRequest = (username, password) => ({
  type: LOGIN_REQUEST,
  username,
  password
});

export const loginSuccess = ({
  lookerUserInfo,
  organizationAvatar,
  token,
  userId,
  username,
  email,
  organization,
  apiKey,
  apiSecret
}) => ({
  type: LOGIN_SUCCESS,
  allowedPages: get(lookerUserInfo, 'allowedPages'),
  allowedDataCategories: get(lookerUserInfo, 'allowedDataCategories'),
  avatar: organizationAvatar,
  token,
  userId,
  username,
  email,
  organization,
  apiKey,
  apiSecret
});

export const loginError = error => ({
  type: LOGIN_ERROR,
  error
});

export const logoutSuccess = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(LOGGED_IN_STORAGE_KEY);
  localStorage.removeItem(USER_PROFILE_STORAGE_KEY);
  localStorage.removeItem('downtime');

  return { type: LOGOUT_SUCCESS };
};

export const logoutError = ({ error, status }) => ({
  type: LOGOUT_ERROR,
  error,
  status
});

export const sessionExpired = () => ({
  type: SESSION_EXPIRED,
  error: {
    message: 'Session expired. Please log in again.'
  }
});

export const login = (username, password) => async dispatch => {
  dispatch(loginRequest(username, password));

  try {
    const res = await tvtApi.login(username, password);
    const userProfile = JSON.stringify({
      allowedPages: get(res, 'lookerUserInfo.allowedPages', []),
      allowedDataCategories: get(
        res,
        'lookerUserInfo.allowedDataCategories',
        []
      ),
      avatar: get(res, 'organizationAvatar', ''),
      userId: get(res, 'userId', ''),
      username: get(res, 'username', ''),
      lastname: get(res, 'lastname', ''),
      email: get(res, 'email', ''),
      organization: get(res, 'organizationName', ''),
      apiKey: get(res, 'apiKey', null),
      apiSecret: get(res, 'apiSecret', null)
    });

    localStorage.setItem(TOKEN_STORAGE_KEY, res.token);
    localStorage.setItem(LOGGED_IN_STORAGE_KEY, true);
    localStorage.setItem(USER_PROFILE_STORAGE_KEY, userProfile);

    dispatch(resetFilters());
    dispatch(resetError());
    dispatch(loginSuccess(res));
    dispatch(getFiltersConfig());
    dispatch(checkHealthStatus());
  } catch (error) {
    dispatch(loginError(error));
    dispatch(logoutSuccess());
    dispatch(resetFilters());
  }
};

export const logout = () => async dispatch => {
  try {
    await tvtApi.logout();

    dispatch(logoutSuccess());
    dispatch(resetFiltersAll());
  } catch (error) {
    dispatch(logoutError(error));
  }
};

export const updateUser = userInfo => dispatch =>
  dispatch({
    type: UPDATE_USER_INFO,
    userInfo
  });
